export interface TitoloResponse {
    id: string;
    nome: string;
    codice: string;
    stato: string;
}